import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation } from 'swiper/modules';
import AutosCarousel from './AutosCarousel';

const faqs = [
  {
    question: "¿Qué es ARRANK! y cómo funciona?",
    answer: "ARRANK! conecta dueños de autos con conductores que necesitan uno para trabajar. Nos ocupamos de todo el proceso de gestión, desde la búsqueda hasta la administración mensual."
  },
  {
    question: "¿Necesito tener un auto nuevo para participar?",
    answer: "No, aceptamos autos en buen estado general, con VTV y papeles al día. Nosotros te ayudamos a evaluar si tu vehículo es apto."
  },
  {
    question: "¿Cómo me aseguro de que cuiden mi auto?",
    answer: "Nuestros conductores son seleccionados cuidadosamente y los vehículos cuentan con seguimiento constante. Además, ofrecemos seguros y mantenimientos periódicos."
  },
  {
    question: "¿Cuánto puedo ganar con mi auto?",
    answer: "Las ganancias varían según el tipo de vehículo, la ciudad y la demanda, pero muchos de nuestros clientes duplicaron sus ingresos mensuales con ARRANK!."
  },
  {
    question: "¿Puedo retirar mi auto en cualquier momento?",
    answer: "Sí, siempre y cuando se respete el contrato de disponibilidad acordado. Somos transparentes y flexibles con nuestros clientes."
  },
  {
    question: "¿Cuánto tiempo debo dejar el auto? ¿Hay contrato?",
    answer: "Sí, trabajamos con contrato, justamente para brindarte mayor seguridad tanto a vos como al conductor. El contrato inicial es de 4 meses mínimo, y luego, si estás conforme con el servicio, podés renovarlo por 6 meses, o por el tiempo que prefieras. Esto nos permite tener una relación clara, con responsabilidades bien marcadas, y que el vehículo esté en movimiento el tiempo suficiente para que sea rentable tanto para vos como para el conductor."
  },
  {
    question: "¿Qué pasa si hay un siniestro? ¿Sigo cobrando esos días?",
    answer: "En caso de que ocurra un siniestro, nuestra prioridad es responder rápido y solucionar el problema cuanto antes. Lo primero que hacemos es gestionar la cobertura con nuestra aseguradora (trabajamos con La Caja, que nos permite actuar con agilidad). Si el daño supera el valor de la franquicia, nosotros como empresa nos hacemos cargo de ese monto, para que el seguro pueda cubrir la reparación completa del auto. Esto te evita a vos tener que afrontar gastos inesperados. Durante el tiempo que el vehículo esté fuera de circulación por reparación, se pausa el pago al propietario, ya que no hay ingresos generados. Pero trabajamos para que el tiempo de inactividad sea el menor posible."
  },
  {
    question: "¿Y si el conductor daña el auto estéticamente o hay faltantes? ¿Quién se hace cargo?",
    answer: "Nosotros tomamos esto muy en serio. Si detectamos mal uso, daños estéticos, faltantes o multas, y se puede comprobar la responsabilidad del conductor, ejecutamos la garantía económica que el conductor deja al iniciar."
  },
];

const FAQSection: React.FC = () => {
  // Detectar si es mobile/tablet
  const [isMobile, setIsMobile] = React.useState(false);
  React.useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 900);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  return (
    <>
      <AutosCarousel />
      <section id="faq" className="section-hyper scroll-snap-section faq-section">
        <div className="section-content-hyper">
          <h2 className="section-title-hyper">Preguntas Frecuentes</h2>
          {isMobile ? (
            <div style={{ maxWidth: '600px', margin: '0 auto', textAlign: 'center' }}>
              {faqs.map((faq, idx) => (
                <div key={idx} style={{ marginBottom: '2rem' }}>
                  <div style={{ fontWeight: 'bold', fontSize: '1.15rem', marginBottom: '0.5rem', color: '#052c4d' }}>{faq.question}</div>
                  <div style={{ fontSize: '1rem', color: '#333', lineHeight: 1.6 }}>{faq.answer}</div>
                </div>
              ))}
            </div>
          ) : (
            <div className="faq-carousel faq-carousel-vistoso" style={{position: 'relative'}}>
              <Swiper
                modules={[Navigation]}
                spaceBetween={24}
                slidesPerView={1}
                navigation
                breakpoints={{
                  0: { slidesPerView: 1 },
                  640: { slidesPerView: 1 },
                  900: { slidesPerView: 1 },
                  1200: { slidesPerView: 1 },
                }}
                className="autos-swiper faq-swiper"
              >
                {faqs.map((faq, index) => (
                  <SwiperSlide key={index}>
                    <div className="faq-card-vistoso animate-fade-in faq-card-lindo">
                      <div className="faq-icon-animado">
                        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="24" cy="24" r="22" fill="#10b981" opacity="0.15"/>
                          <circle cx="24" cy="24" r="18" fill="#10b981" opacity="0.25"/>
                          <path d="M24 32C25.1046 32 26 31.1046 26 30C26 28.8954 25.1046 28 24 28C22.8954 28 22 28.8954 22 30C22 31.1046 22.8954 32 24 32Z" fill="#052c4d"/>
                          <path d="M24 16C20.6863 16 18 18.6863 18 22H20C20 19.7909 21.7909 18 24 18C26.2091 18 28 19.7909 28 22C28 24 25 24.5 25 27H23C23 24.5 20 24 20 22C20 18.6863 22.6863 16 26 16C29.3137 16 32 18.6863 32 22C32 25.3137 29.3137 28 26 28H24" stroke="#052c4d" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                      <h4 className="faq-question-vistoso">{faq.question}</h4>
                      <p className="faq-answer-vistoso">{faq.answer}</p>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          )}
      </div>
    </section>
    </>
  );

}
export default FAQSection;